import { Injectable } from '@angular/core';
import { Estado } from '../models/estado';
import { Instituicao } from '../models/instituicao';
import { Municipio } from '../models/municipio';

@Injectable({
  providedIn: 'root'
})
export class InstituicoesService {
  private instituicoes: Instituicao[];
  private estados: Estado[];
  private municipios: Municipio[];

  constructor() { }

  setInstituicoes(escolas: Instituicao[]) {
    this.instituicoes = escolas;
  }

  getInstituicoes() {
    return this.instituicoes;
  }

  setEstados(ufs: Estado[]) {
    this.estados = ufs;
  }

  getEstados() {
    return this.estados;
  }

  setMunicipios(municipios: Municipio[]) {
    this.municipios = municipios;
  }

  getMunicipios() {
    return this.municipios;
  }
}
